import { TeamsAndUsersList } from '../../../../components/settings/types/users-and-teams';
import store from '../../../../store';
import { Permissions } from '../../../utils/access-control/enums/permissions';
import hasPermission from '../../../utils/access-control/has-permission';
import { TeamForFilter } from '../types';

export const getOptions = (
  teamsAndUsersList: TeamsAndUsersList[],
): TeamForFilter[] => {
  const formattedTeams: TeamForFilter[] = [];
  const showAsMembersOnly =
    (!hasPermission(Permissions.ACCOUNT_USER_READ) &&
      !hasPermission(Permissions.TEAM_USER_READ)) ||
    store?.getState()?.home?.isAgencyUser;

  if (teamsAndUsersList?.length) {
    // Loop through the teams
    teamsAndUsersList.forEach((team) => {
      // Show Uncategorized User As Members
      if (team.id === null && showAsMembersOnly) {
        // If the team has no ID (null), format its users
        if (team.users) {
          team.users.forEach((user) => {
            const userTeam: TeamForFilter = {
              key: `${user.id}`,
              id: user.id,
              name: user.userName,
              email: user.email,
              type: 'user',
            };
            formattedTeams.push(userTeam);
          });
        }
      } else {
        // If the team has an ID, format it as a team
        const teamForFilter: TeamForFilter = {
          key: `${team?.id || 0}`,
          id: team?.id || 0,
          name: team?.id ? team.teamName : 'Uncategorized',
          type: 'team',
          users: team.users,
          isDisabled: team.users.length === 0,
        };

        formattedTeams.push(teamForFilter);
      }
    });
  }

  return formattedTeams;
};
